// extracted by mini-css-extract-plugin
export default {"roll__title":"Roll_roll__title__4nZle","roll__subtitle":"Roll_roll__subtitle__EAfxV","roll__link":"Roll_roll__link__azkNm"};